import MedicalTreatments from "@/components/features/matter/medical-treatments/MedicalTreatments";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute(
  "/_auth/matters/$matterId/_layout/medical-treatments",
)({
  component: RouteComponent,
  validateSearch: z.object({
    medicalTreatmentId: z.string().optional(),
    appointmentId: z.string().optional(),
    billId: z.string().optional(),
    recordId: z.string().optional(),
    planId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { medicalTreatmentId, appointmentId, billId, recordId, planId } =
    Route.useSearch();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data as unknown;
  const isDeletedMatter =
    Array.isArray(matterData) ||
    !(matterData as { id?: string } | undefined)?.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  const matter = matterDetails.data;
  return (
    <MedicalTreatments
      matter={matter}
      searchMedicalTreatmentId={medicalTreatmentId}
      searchAppointmentId={appointmentId}
      searchBillId={billId}
      searchRecordId={recordId}
      searchPlanId={planId}
    />
  );
}
